<template>
  <div class="submission-modal">
    <div class="modal-content">
      <div class="icon-container">
        <div class="check-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#2E7BFF" />
            <path d="M7 12L10.5 15.5L17 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="message-container">
        <h2 class="title">Your Submission is Under Review</h2>
        <p class="description">We have received your submission, please wait 2x24 hour for approval</p>
      </div>
      <div class="button-container">
        <argon-button @click="submit">OK</argon-button>
      </div>
    </div>
  </div>
</template>

<script>
import { nextPopup } from '../../api/company';
import { buildFormData } from '../../utils/param-builder';
import ArgonButton from "@/components/ArgonButton";

export default {
  name: "SubmissionReviewModal",
  components: {
    ArgonButton
  },
  props: {
    show: { type: Boolean, default: false }
  },
  data(){
    return {
      merchantId : 0,
      current_popup : 'under_review'
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    async submit(){
      try{
        const body = {
          merchant_id : this.merchantId,
          current_popup : this.current_popup
        }

        const formData = buildFormData(body);

        const response = await nextPopup(formData);
        if(response.status === 'success'){
          this.$emit('close');
          this.$router.push('/home'); 
        }
      }catch(e){
        console.error(e);
      }
    }
  },
  created(){
    this.merchantId = localStorage.getItem("merchantId");
  }
};
</script>

<style scoped>
.submission-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 600px;
  text-align: center;
  border: 1px solid #c8d1e0;
}

.icon-container {
  display: flex;
  justify-content: center;
  margin: 0;
}

.check-icon {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.check-icon svg {
  width: 40px;
  height: 40px;
}

.message-container {
  padding: 10px;
  margin: 24px 0;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.description {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.button-container {
  margin-top: 20px;
}

.ok-button {
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 30px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.ok-button:hover {
  background-color: #45a049;
}
</style>